import { Component, OnInit, OnDestroy, NgZone, EventEmitter, Input, ViewChild } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ModalDirective } from 'ngx-bootstrap/modal';


import { Subscription } from 'rxjs';

import {
    AssociationService,
    AuthorizationService,
    CompanyService,
    MinesiteService,
    Company,
    CompanyMinesites,
    Minesite,
    GlobalService,
    DeleteConfirmation,
    ToastrService
} from './../../../../shared/index';

@Component({
    selector: 'company-entity',
    templateUrl: './company-entity.html',
    standalone: false
})

export class CompanyEntityComponent implements OnInit, OnDestroy {
    @Input('company') company: Company = new Company();

    public minesitesVisible = false
    public minesites: Minesite[] = [];
    public modified: Date = new Date(Date.now());
    public subscriptions: Subscription[] = [];
    public textColor = '';
    public label: string;
    @Input('live') live = true;
    Is_Published = true
    @ViewChild('DeleteCompany') ModelDeleteCompany: ModalDirective;
    constructor(
        private _associationService: AssociationService,
        private _ngZone: NgZone,
        private _companyService: CompanyService,
        private _minesiteService: MinesiteService,
        private _globalService: GlobalService,
        private _toastrService: ToastrService
    ) {
        this.Is_Published = true;
        this.subscriptions.push(this._minesiteService.companyMinesiteChanges.subscribe((info: CompanyMinesites) => {
            if (this.company.Associated_ID != null && this.company.Associated_ID != undefined) {
                if (info.CompanyId == this.company.Associated_ID) {
                    this._ngZone.run(() => {
                        this.minesites = info.Minesites;
                    });
                } else {
                    if (info.CompanyId == this.company.Id) {
                        this._ngZone.run(() => {
                            this.minesites = info.Minesites;
                        });
                    }
                }
            } else {
                if (info.CompanyId == this.company.Id) {
                    this._ngZone.run(() => {
                        this.minesites = info.Minesites;
                    });
                }
            }
        }));
        this.subscriptions.push(this._companyService.companyChange.subscribe((info: Company) => {
            if (info.Id == this.company.Id) {
                this._ngZone.run(() => {
                    this.company = info;
                    setTimeout(() => {
                        this.modified = new Date(Date.now());
                    }, 500);
                });
            }
        }));
        //this.subscriptions.push(this._globalService.deleteResultEx.subscribe((result: DeleteConfirmation) => {
        //    if (result.EntityType == "company" && result.Confirmed && result.EntityId == this.company.Id) {
        //        this._companyService.delete(this.company.Id);
        //    }
        //}));
    }

    ngOnInit(): void {
        this.label = this.company.Name;
        //if (!this.live) {
        //    this.textColor = "text-warning";
        //    this.label = "**" + this.company.Name + "**";
        //}
    }
    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    // staging envrionment changes
    public getMinesites(): void {
        if (this.live) {
            this.minesitesVisible = !this.minesitesVisible;
            if (this.minesitesVisible) {
                this._minesiteService.getMinesitesForCompany(this.company.Id);
            }
        } else {
            this.minesitesVisible = !this.minesitesVisible;
            if (this.minesitesVisible) {
                this._minesiteService.getMinesitesForCompanyStaging(this.company.Id);
            }
        }
    }
    public deleteCompany(): void {
        if (Number(localStorage.getItem('Lock')) == 1) {
            this._toastrService.displayToastrMessage('error', localStorage.getItem('Msg'), 'Environment Status!');
            return;
        }
        //this._globalService.confirmDelete("company", this.company.Name, this.company.Id);
        this.ModelDeleteCompany.show();
    }

    public edit(): void {
        if (Number(localStorage.getItem('Lock')) == 1) {
            this._toastrService.displayToastrMessage('error', localStorage.getItem('Msg'), 'Environment Status!');
            return;
        }
        this._companyService.edit(this.company);
    }

    public showDetails(): void {
        this._companyService.showDetails(this.company, this.live);
    }

    DeleteSelectedCompany() {
        this.ModelDeleteCompany.hide();
        this._companyService.delete(this.company.Id);
        this.live = false;
    }
    Close(): void {
        this.ModelDeleteCompany.hide();
    }
    public cdkDropEventTriggered(event: any): void {
        if (event.item.data instanceof Minesite) {
            if (Number(localStorage.getItem('Lock')) === 1) {
                this._toastrService.displayToastrMessage('error', localStorage.getItem('Msg'), 'Environment Status!');
                return;
            }
            this._associationService.associateMinesiteToCompany(this.company.Id, event.item.data.Minesite_ID, false);
        }
    }
}
